import React from "react";
import { useTranslation } from "react-i18next";
import { getNativeAppQueryParamsValuesByKey } from "../../../../constants/AppMethod";
import { ENVSettings } from "../../../../constants/ENVSettings";


const LearnMore = ({ type }) => {
    const { t } = useTranslation(["translation"]);

    const request_from = getNativeAppQueryParamsValuesByKey("request_from")
    const service_status = getNativeAppQueryParamsValuesByKey("service_status")
    const utm_source = getNativeAppQueryParamsValuesByKey("utm_source")
    const utm_medium = getNativeAppQueryParamsValuesByKey("utm_medium")
    const utm_campaign = getNativeAppQueryParamsValuesByKey("utm_campaign")
    const utm_content = getNativeAppQueryParamsValuesByKey("utm_content")

    let baseLink;

    if (type === "BPLUS") {
        baseLink = ENVSettings.BROTHER_CONNECT_BASE_URL
    }

    if (type === "ECOPRO") {
        baseLink = `${ENVSettings.MAIN_BASE_URL}ecopro`;
    }

    const queryParams = new URLSearchParams({
        ...(request_from && { request_from }),
        ...(service_status && { service_status }),
        ...(utm_source && { utm_source }),
        ...(utm_medium && { utm_medium }),
        ...(utm_campaign && { utm_campaign }),
        ...(utm_content && { utm_content })
    }).toString();
   
    const learnMoreLink = queryParams
        ? `${baseLink}?${queryParams}`
        : baseLink;

    return (
        <a href={learnMoreLink} target="_blank" rel="noopener noreferrer">{t('BENEFITS_OF_SUPPLIES.LEARN_MORE')}</a>
    );
};

export default LearnMore;